import { MenuItem, Menu, Box } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";
import { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    item: {
        paddingRight: theme.spacing(2)
    },
    labelArrow: {
        marginLeft: "auto"
    }
}));


interface Props
{
    disabled?: boolean
    parentOpen: boolean
    label: React.ReactElement
    children: React.ReactNode
}

export default function NestedMenuItem({ parentOpen, label, children, disabled }: Props)
{
    const classes = useStyles();
    const [item, setItem] = useState<HTMLElement | null>(null);
    const [overMenu, setOverMenu] = useState(false);
    const [overItem, setOverItem] = useState(false);

    const open = parentOpen && (overMenu || overItem) && (!disabled);
    return <Box ref={setItem} onMouseEnter={() => setOverItem(true)} onMouseLeave={() => { setOverItem(false) }}>
        <MenuItem className={classes.item} disabled={disabled}>
            {label}<ArrowForwardIos className={classes.labelArrow} fontSize={"small"} />
        </MenuItem >
        <Menu
            open={parentOpen && open}
            anchorEl={item}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            style={{ pointerEvents: 'none' }}
        >
            <Box style={{ pointerEvents: 'auto' }}
                onMouseEnter={() => setOverMenu(true)}
                onMouseLeave={() => setOverMenu(false)}>
                {children}
            </Box>
        </Menu >
    </Box >
}